// extracted by mini-css-extract-plugin
export default {"article":"article--zJ8r8","car-item":"car-item--afSYq","content":"content--ZBSPo","title":"title--ZJIAY","time":"time--qR04o"};